import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { BootSplash } from '@/components/auth/boot-splash';
import { fetchMe, ME_QUERY_KEY, ME_STALE_TIME } from '@/hooks/use-auth';

const SESSION_KEY = 'underline:boot_splash_v1';

function hasShownBoot(): boolean {
  try {
    return sessionStorage.getItem(SESSION_KEY) === '1';
  } catch {
    return true;
  }
}

export function BootGate({ children }: { children: React.ReactNode }) {
  const [done, setDone] = useState(hasShownBoot);
  const [authSettled, setAuthSettled] = useState(false);
  const qc = useQueryClient();

  // Enquanto o boot está visível, prefetcha /auth/me. Quando resolver, o BootSplash
  // pode fechar — assim o app já revela direto o painel/login, sem o spinner do RequireAuth.
  useEffect(() => {
    if (done) {
      setAuthSettled(true);
      return;
    }
    let active = true;
    void qc
      .prefetchQuery({
        queryKey: ME_QUERY_KEY,
        queryFn: fetchMe,
        staleTime: ME_STALE_TIME,
        retry: false,
      })
      .finally(() => {
        if (active) setAuthSettled(true);
      });
    return () => {
      active = false;
    };
  }, [done, qc]);

  function handleDone() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch {
      // sessionStorage indisponível — segue
    }
    setDone(true);
  }

  return (
    <>
      {children}
      {!done && <BootSplash gateReady={authSettled} onDone={handleDone} />}
    </>
  );
}
